export class EditCondition {
	public empCd: string
	public empNm: string
	public empKnm: string
	public useableFlg: boolean
	public empEmail: string
	public empSubEmail: string
	public loginId: string
	public password: string
	public divisionCd: string
	public empTypeCd: string
	public payTypeCd: string
	public workTimeScheduleBase:string
	public overtimeCalcFlg: boolean
	public expectedOvertime: string
	public workPlace: string
	public busCommuteFlg: boolean 
	public useStartDate: string
	public useEndDate: string
	public roleSales: boolean
	public roleLeader: boolean
	public roleManager: boolean
	public roleBusinessAdmin: boolean
	public roleWorkingHoursAdmin: boolean
	public shiftTimeStartFirst: string
	public shiftTimeEndFirst: string
	public restTimeStart01First: string
	public restTimeEnd01First: string
	public restTimeStart02First: string
	public restTimeEnd02First: string
	public restTimeStart03First: string
	public restTimeEnd03First: string
	public restTimeStart04First: string
	public restTimeEnd04First: string
	public restTimeStart05First: string
	public restTimeEnd05First: string
	public restTimeStart06First: string
	public restTimeEnd06First: string
	public restTimeStart07First: string
	public restTimeEnd07First: string
	public restTimeStart08First: string
	public restTimeEnd08First: string
	public restTimeStart09First: string
	public restTimeEnd09First: string
	public restTimeStart10First: string
	public restTimeEnd10First: string
	public morningOffTimeStartFirst: string
	public morningOffTimeEndFirst: string
	public afternoonOffTimeStartFirst: string
	public afternoonOffTimeEndFirst: string
	public shiftTimeStartSecond: string
	public shiftTimeEndSecond: string
	public restTimeStart01Second: string
	public restTimeEnd01Second: string
	public restTimeStart02Second: string
	public restTimeEnd02Second: string
	public restTimeStart03Second: string
	public restTimeEnd03Second: string
	public restTimeStart04Second: string
	public restTimeEnd04Second: string
	public restTimeStart05Second: string
	public restTimeEnd05Second: string
	public restTimeStart06Second: string
	public restTimeEnd06Second: string
	public restTimeStart07Second: string
	public restTimeEnd07Second: string
	public restTimeStart08Second: string
	public restTimeEnd08Second: string
	public restTimeStart09Second: string
	public restTimeEnd09Second: string
	public restTimeStart10Second: string
	public restTimeEnd10Second: string
	public morningOffTimeStartSecond: string
	public morningOffTimeEndSecond: string
	public afternoonOffTimeStartSecond: string
	public afternoonOffTimeEndSecond: string
	public shiftTimeStartThird: string
	public shiftTimeEndThird: string
	public restTimeStart01Third: string
	public restTimeEnd01Third: string
	public restTimeStart02Third: string
	public restTimeEnd02Third: string
	public restTimeStart03Third: string
	public restTimeEnd03Third: string
	public restTimeStart04Third: string
	public restTimeEnd04Third: string
	public restTimeStart05Third: string
	public restTimeEnd05Third: string
	public restTimeStart06Third: string
	public restTimeEnd06Third: string
	public restTimeStart07Third: string
	public restTimeEnd07Third: string
	public restTimeStart08Third: string
	public restTimeEnd08Third: string
	public restTimeStart09Third: string
	public restTimeEnd09Third: string
	public restTimeStart10Third: string
	public restTimeEnd10Third: string
	public morningOffTimeStartThird: string
	public morningOffTimeEndThird: string
	public afternoonOffTimeStartThird: string
	public afternoonOffTimeEndThird: string
	public sundayFlg: boolean
	public mondayFlg: boolean
	public tuesdayFlg: boolean
	public wednesdayFlg: boolean
	public thursdayFlg: boolean
	public fridayFlg: boolean
	public saturdayFlg: boolean
	public dailyAllowanceAmount: string
	public sortPaymentCheck: string
	public delFlg: boolean
	public renewDate: Date
	public renewUser: string
	public renewUserNm: string
}
